import { create } from 'zustand';
import { ConfigStore, ConfigStoreState } from './index.types';

const initialState: ConfigStoreState = {
  signedInPersonConfig: null,
};

export const useConfigStore = create<ConfigStore>()((set) => ({
  ...initialState,
  setSignedInPersonConfig: (signedInPersonConfig) =>
    set({ signedInPersonConfig }),
}));
